module.exports = __webpack_public_path__ + "fd3fc7d149b953ebf980597a102fcfc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OurTeam/dominika-krupkova.png
// module id = 1218
// module chunks = 0